module.exports = __webpack_public_path__ + "static/media/YF46_0.4c595987.jpg";